import { render } from "./CategoriesAdmin.vue?vue&type=template&id=7eacdc40"
import script from "./CategoriesAdmin.vue?vue&type=script&lang=js"
export * from "./CategoriesAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__